import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonContactRequestGridPart } from '../../../../../ui/widget';
import { AdmissionsEngagementsService } from '../../admissions-engagements.service';

@Component({
	selector: 'admissions-contact-request-view-part',
	standalone: true,
	imports: [CommonContactRequestGridPart],
	templateUrl: './contact-request-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./contact-request-view.part.scss'],
})
export class AdmissionsContactReqFollowUpsViewPart {
	public readonly pageService = inject(AdmissionsEngagementsService);
	public contactRequests = computed(() => (this.pageService.contactRequests() || []));
}